import BaseEntity from "./BaseEntity";
import TSEnumerationLocale from "./EnumerationLocale";

export default class TSEnumeration extends BaseEntity {
  CollectionName = "";
  EnumerationLocales: TSEnumerationLocale[] = [];
}
